// Botanical Boys bespoke theme. Single source of truth for every color/font
// in the What's On widget — generalizing later means swapping this object.
export type CategoryStyle = {
  key: string;
  label: string;
  bg: string;
  fg: string;
  dot: string;
};

export const PALETTE = {
  pageBg: "#E1D9D0",
  ink: "#2E2623",
  border: "#AF9C87",
  panel: "#D8C9B8",
  accent: "#997C60",
  muted: "#7d6a52",
  mutedAlt: "#8a7660",
  cell: "#ffffff",
} as const;

export const FONTS = {
  googleCssUrl:
    "https://fonts.googleapis.com/css2?family=Newsreader:opsz,wght@6..72,400..700&family=Work+Sans:wght@400..600&display=swap",
  serif: `"Newsreader", Georgia, "Times New Roman", serif`,
  sans: `"Work Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`,
} as const;

// Keyed by lowercase tag name (Tag.name is stored lowercase).
// Private Hire / Partner Event have no Baluu data source today but their
// colors stay mapped so adding those tags later just works.
export const CATEGORY_MAP: Record<string, { bg: string; fg: string; dot: string }> = {
  workshop: { bg: "#e7efe3", fg: "#2E2623", dot: "#5c7d52" },
  wine: { bg: "#f3e5ea", fg: "#7a3b52", dot: "#9c5270" },
  food: { bg: "#f7e8dc", fg: "#997C60", dot: "#c17a45" },
  "private hire": { bg: "#efe6d8", fg: "#5a4f3f", dot: "#a3855c" },
  "partner event": { bg: "#e2ebee", fg: "#3d5a66", dot: "#5b8494" },
};

export const FALLBACK_CATEGORY: CategoryStyle = {
  key: "event",
  label: "Event",
  bg: "#efe6d8",
  fg: "#5a4f3f",
  dot: "#997C60",
};
